import { Options, Vue } from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import ApplicationMenu from '../application-menu/index.vue';
import { EventEmitter } from 'events';
import { RouteN } from '@/trust-atcs-app/constants/router-name';
import store from '@/trust-atcs-app/store';
import { AuthorizedUser } from '@/trust-atcs-app/models/authorized-user';
import { AuthenticationStatusType } from '@/trust-atcs-app/modules/authentication/authentication-status';

@Options<AccountInfoPanel>({
  components: {
    ApplicationMenu
  }
})
export default class AccountInfoPanel extends Vue {


  @Prop({ default: null })
  private isExternal!: boolean;

  @Ref('dropDownMenu')
  private dropDownMenuUI!: HTMLElement;

  public showMenu = false;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  created(): void {
    window.addEventListener('click', this.clickedElement);
  }

  beforeUnmount(): void {
    window.removeEventListener('click', this.clickedElement);
  }

  private clickedElement(e: MouseEvent): void | boolean {
    const el: HTMLElement = this.dropDownMenuUI;
    const elBut: HTMLElement = this.dropDownMenuUI;
    const target: HTMLElement = e.target as HTMLElement;
    if (el !== target && elBut !== target) {
      this.showMenu = false;
    }
  }

  private onMenuClicked() {
    switch (this.$route.name) {
      case RouteN.ATCS.Home.n:
      case RouteN.ATCS.Main.n:
      case RouteN.ATCS.ImpersonateUser.n:
      case RouteN.ATCS.DashboardMain.n:
      case RouteN.ATCS.DashboardHome.n:
      case RouteN.ATCS.EEHome.n:
      case RouteN.ATCS.EESignUp.n:
        this.showMenu = !this.showMenu;
        break;
      case RouteN.ATCS.FormPartA.n:
      case RouteN.ATCS.FormPartB.n:
      case RouteN.ATCS.FormEer.n:
        if (this.isConfirmationPage) {
          this.showMenu = !this.showMenu;
        } else if (!this.$route.query.sec) {
          this.$router.push({ name: RouteN.ATCS.Home.n });
        } else {
          this.saveCloseClick();
        }
        break;
      case RouteN.ATCS.ManageAuthorisedSignatories.n:
        this.saveCloseClick();
        break;
      default:
        this.$router.push({ name: RouteN.ATCS.Home.n });
        break;
    }

  }

  get infoTextRow0(): string {
    try {
      return this.userAccount?.user?.firstName + ' ' + this.userAccount?.user?.lastName;
    } catch (err) {
      console.log(err);
      return '';
    }
  }

  get infoTextRow1(): string {
    try {
      if (this.userAccount?.user.impersonatedLawId) {
        return '(' + this.userAccount?.user?.originalFirstName + ' ' + this.userAccount?.user?.originalLastName + ')';
      } else {
        return 'LawID ' + this.userAccount?.user?.lawId;
      }
    } catch (err) {
      console.log(err);
      return '';
    }
  }

  get menuButtonText(): string {

    switch (this.$route.name) {
      case RouteN.ATCS.Home.n:
      case RouteN.ATCS.Main.n:
      case RouteN.ATCS.ImpersonateUser.n:
      case RouteN.ATCS.DashboardMain.n:
      case RouteN.ATCS.DashboardHome.n:
      case RouteN.ATCS.EEHome.n:
      case RouteN.ATCS.EESignUp.n:
        return 'Menu';
      case RouteN.ATCS.FormPartA.n:
      case RouteN.ATCS.FormPartB.n:
      case RouteN.ATCS.FormEer.n:
        if (this.isConfirmationPage) {
          return 'Menu';
        } else {
          return 'Save & Close';
        }
      default:
        return 'Close';
    }

  }


  get menuIcon(): string {
    switch (this.$route.name) {
      case RouteN.ATCS.Home.n:
      case RouteN.ATCS.Main.n:
      case RouteN.ATCS.ImpersonateUser.n:
      case RouteN.ATCS.DashboardMain.n:
      case RouteN.ATCS.DashboardHome.n:
      case RouteN.ATCS.EEHome.n:
      case RouteN.ATCS.EESignUp.n:
        return this.showMenu ? 'fa-times' : 'fa-bars';
      case RouteN.ATCS.FormPartA.n:
      case RouteN.ATCS.FormPartB.n:
      case RouteN.ATCS.ManageAuthorisedSignatories.n:
      case RouteN.ATCS.FormEer.n:
        if (this.isConfirmationPage) {
          return this.showMenu ? 'fa-times' : 'fa-bars';
        } else {
          return 'fa-times';
        }
      default:
        return 'fa-bars';
    }

  }

  get selectionTypeClassName(): string {
    // switch (this.$route.name) {
    // case RouteN.Mars.Committee.n:
    //   return 'committee';
    // case RouteN.Mars.Member.n:
    //   return 'committee-member';
    //   default:
    // return '';
    // }
    return '';
  }

  get isConfirmationPage(): boolean {
    const section: string = this.$route.query.sec as string || '';
    return section.indexOf('confirmation') > -1;
  }

  get isUpdating(): boolean {
    const section: string = this.$route.query.sec as string || '';
    return section.indexOf('update') == 0;
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  get appAccessPermitted(): boolean {
    return this.userAccount.authenticationStatus === AuthenticationStatusType.AppAccessPermitted ||
      this.userAccount.authenticationStatus === AuthenticationStatusType.LoggedIn;
  }

  private saveCloseClick() {
    this.eventCtrl.emit('save-and-close');
  }

}
